import { add, angleOf, dist, fromPolar, scale, sub, toDegrees, vec, type Vec2 } from './vec2';

/** Angles of the four quadrant points, counter-clockwise from +x. */
export const QUADRANT_ANGLES: readonly number[] = [0, 90, 180, 270];

export function projectToRadius(center: Vec2, radius: number, p: Vec2): Vec2 {
  const d = sub(p, center);
  const l = Math.hypot(d.x, d.y);
  return l === 0 ? vec(center.x + radius, center.y) : add(center, scale(d, radius / l));
}

/** The near and far points of a circle on the line through its center and `from`. */
export function circlePerpendiculars(center: Vec2, radius: number, from: Vec2): Vec2[] {
  if (dist(from, center) < 1e-9) return [];
  const near = projectToRadius(center, radius, from);
  return [near, add(center, sub(center, near))];
}

/** Tangent points on a circle from an outside point; none from inside. */
export function circleTangents(center: Vec2, radius: number, from: Vec2): Vec2[] {
  const d = dist(from, center);
  if (d < radius + 1e-9) return [];
  const base = angleOf(sub(from, center));
  const spread = toDegrees(Math.acos(radius / d));
  return [base + spread, base - spread].map((angle) => fromPolar(center, radius, angle));
}
